import { useContext, useEffect, useState } from "react";
import { Link, Outlet } from 'react-router-dom'
import './NewUserManagment.css'
import Typography from '@mui/material/Typography';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { Paper, useTheme } from "@mui/material";
import { AppEnvSetting } from "../ts/common";
import { AdminContext } from "../contexts/AdminContext";
import { RoleObject } from "../interfaces/ApplicationInterfaces";

interface NewUserManagementProps {
    triggerPopUp: (msg: string) => void
}

const NewUserManagementPage = (props: NewUserManagementProps) => {
    const [value, setValue] = useState(0);
    const { adminCredentials } = useContext(AdminContext);
    const [showScimPage, setShowScimPage] = useState<boolean>(false);

    useEffect(()=>{
      if(adminCredentials){
        if(adminCredentials.isSuperAdmin) setShowScimPage(true);
        else {
          adminCredentials.roles.some((role: RoleObject)=>
            AppEnvSetting.pageViewAccess?.scim == role.roleId 
          ) ? setShowScimPage(true) : setShowScimPage(false);
        }
      }else{
        setShowScimPage(false);
      }
    },[adminCredentials]);
    

    const theme = useTheme();
    return (
        <Paper 
          component={"main"} 
          className='off-white'
          sx={{backgroundColor: theme.palette.background.default}}
        >
            <Typography variant="h5">
            New User Management
            </Typography>
            <Tabs value={value} onChange={(event: React.SyntheticEvent, newValue: number) => setValue(newValue)}>
                <Tab component={Link} to={`addUser`} label="Add User" />
                <Tab component={Link} to={`massPreload`} label="Mass Preload Users" />
                <Tab component={Link} to={`resendInvite`} label="Resend Invite Email" />
                {showScimPage && AppEnvSetting.showScimApplication && <Tab component={Link} to={`scim`} label="SCIM Application" /> }
            </Tabs>
            <Outlet />
        </Paper>
    )
}

export default NewUserManagementPage
